/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeADownRightIcon16Light } from './ArrowShapeADownRightIcon16Light';
import { ArrowShapeADownRightIcon16Regular } from './ArrowShapeADownRightIcon16Regular';
import { ArrowShapeADownRightIcon16Solid } from './ArrowShapeADownRightIcon16Solid';
import { ArrowShapeADownRightIcon20Light } from './ArrowShapeADownRightIcon20Light';
import { ArrowShapeADownRightIcon20Regular } from './ArrowShapeADownRightIcon20Regular';
import { ArrowShapeADownRightIcon20Solid } from './ArrowShapeADownRightIcon20Solid';
import { ArrowShapeADownRightIcon24Regular } from './ArrowShapeADownRightIcon24Regular';
import { ArrowShapeADownRightIcon24Solid } from './ArrowShapeADownRightIcon24Solid';
import { ArrowShapeADownRightIcon32Regular } from './ArrowShapeADownRightIcon32Regular';
import { ArrowShapeADownRightIcon64Regular } from './ArrowShapeADownRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeADownRightIcon16Light,
        regular: ArrowShapeADownRightIcon16Regular,
        solid: ArrowShapeADownRightIcon16Solid,
    },
    20: {
        light: ArrowShapeADownRightIcon20Light,
        regular: ArrowShapeADownRightIcon20Regular,
        solid: ArrowShapeADownRightIcon20Solid,
    },
    24: {
        regular: ArrowShapeADownRightIcon24Regular,
        solid: ArrowShapeADownRightIcon24Solid,
    },
    32: {
        regular: ArrowShapeADownRightIcon32Regular,
    },
    64: {
        regular: ArrowShapeADownRightIcon64Regular,
    },
};
export var ArrowShapeADownRightIcon = forwardRef('ArrowShapeADownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
